<script>

    import {bytesToHuman, filenameToIcon} from "../Utils";
    import API from "../../../class/API";
    import { t } from "../../../i18n";

    export let path;
    export let name;
    export let size;
    export let access;

    let iconUrl = filenameToIcon(name);

    $: isLoading = false;


    let doDownload = function(filename, type="text/plain")
    {
        isLoading = true;


        API('notes.files.dl', {path, filename}, {decoder: p=>p.blob(), parser: p=>p,})
            .then(function(data){
                const a = document.createElement("a");
                a.style.display = "none";
                document.body.appendChild(a);
                a.href = window.URL.createObjectURL(new Blob([data], { type }));
                a.setAttribute("download", filename);
                a.click();
                window.URL.revokeObjectURL(a.href);
                document.body.removeChild(a);
            })
            .catch(()=>alert($t('common.download_error')))
            .finally(()=>setTimeout(()=>isLoading = false, 1000))
    }
</script>


<div class="col-12 col-md-6 col-xl-3">
    <div class="card border shadow-none mb-1 app-file-info"  style="{isLoading ? 'filter: grayscale(1);opacity: 0.2; pointer-events:none;':''}" on:click={()=>doDownload(name)}>
        <div class="card-content">
            <div class="app-file-content-logo card-img-top">
                <i class="bx bx-dots-vertical-rounded app-file-edit-icon d-block float-right"></i>
                <img class="d-block mx-auto" src={iconUrl} height="38" width="30" alt="File Icon">
            </div>
            <div class="card-body p-50">
                <div class="app-file-recent-details">
                    <div class="app-file-name font-size-small font-weight-bold">{name}</div>
                    <div class="app-file-size font-size-small text-muted mb-25">{bytesToHuman(size)}</div>
                    {#if access}<div class="app-file-last-access font-size-small text-muted">{$t('files.last_accessed')} {access}</div>{/if}
                </div>
            </div>
        </div>
    </div>
</div>
